<template>
  <div class="counter">
    <button
      class="counter-btn"
      @click.prevent="sub"
      :disabled="!decrementer || counter <= 0"
    >
      -
    </button>
    <div class="counter-input">
      <input
        type="text"
        v-model="counter"
        readonly
        :disabled="(!decrementer || counter <= 0) && !incrementer"
      >
    </div>
    <button
      class="counter-btn"
      @click.prevent="add"
      :disabled="!incrementer"
    >
      +
    </button>
  </div>
</template>

<script>
import Btn from './Btn'
export default {
  components: {
    Btn
  },

  name: 'Counter',

  props: {
    value: { type: Number, default: 0 },
    incrementer: { Type: Boolean, default: true },
    decrementer: { Type: Boolean, default: true },
    max: null
  },

  data () {
    return {
      counter: this.value
    }
  },

  watch: {
    value (a) {
      this.counter = a
    },
    counter (a, b) {
      this.$emit(a > b ? 'add' : 'sub')
      this.$emit('input', a)
    }
  },

  methods: {
    sub () {
      if (this.counter) {
        this.counter -= 1
      }
    },
    add () {
      if (!this.max || this.counter < this.max) {
        this.counter += 1
        // this.$emit('add')
      }
    }
  }
}
</script>
